// ════════════════════════════════════════════════════════════════════
// LYRAEA — Firebase
// ONE PROJECT: terror-tcg. Never a second, for any reason. Lyraea is a
// title on the shared Empire backend, so a listener is the same person
// they are on the Pier, holding the same Crests and the same Mark.
//
// `databaseURL` is included deliberately — the Firebase console OMITS it
// from the snippet it hands you, and its absence has cost a real
// debugging session in this Empire before.
// ════════════════════════════════════════════════════════════════════

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBOJk0sqgXPz75mGGFu12zsqMtsm2RDO6I",
  authDomain: "terror-tcg.firebaseapp.com",
  databaseURL: "https://terror-tcg-default-rtdb.firebaseio.com",
  projectId: "terror-tcg",
  storageBucket: "terror-tcg.firebasestorage.app",
  messagingSenderId: "47395896249",
  appId: "1:47395896249:web:59ae23e554366159c09468",
};

const app = initializeApp(firebaseConfig);
export const db   = getDatabase(app);
export const auth = getAuth(app);
